'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _saveSearch = require('./remote/saveSearch');

var SaveSearch = {
    fetchSavedSearches: _saveSearch.SaveSearchRemote.fetchSavedSearches,
    fetchSavedSearchItems: _saveSearch.SaveSearchRemote.fetchSavedSearchItems,
    postDeleteSavedSearch: _saveSearch.SaveSearchRemote.postDeleteSavedSearch,
    postIsSavedSearch: _saveSearch.SaveSearchRemote.postIsSavedSearch,
    postSaveSearch: _saveSearch.SaveSearchRemote.postSaveSearch,
    postSubscribeToSavedSearch: _saveSearch.SaveSearchRemote.postSubscribeToSavedSearch,
    postUnsubscribeFromSavedSearch: _saveSearch.SaveSearchRemote.postUnsubscribeFromSavedSearch
};

exports.default = SaveSearch;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/saveSearch.js
// module id = Ykd8
// module chunks = 60